import { observer } from 'mobx-react';
import ShareUrlsOptionsStore from '../DeepLinksOptionsStore';
import { SearchParameter, SearchParameters } from '../../../../../../ListFilter/Types';
import State from './State';

interface Props {
  duplicateProgramDeepLinkCount: number;
  optionsStore: ShareUrlsOptionsStore;
  searchParameters: SearchParameters;
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
}

function Filters({
  duplicateProgramDeepLinkCount,
  optionsStore,
  searchParameters,
  updatingSearchParameters,
}: Props) {
  return (
    <div className="max-w-clientPortalMaxWidth px-2.5 lg:px-12 my-4">
      <div className="flex items-center">
        <State
          duplicateProgramDeepLinkCount={duplicateProgramDeepLinkCount}
          optionsStore={optionsStore}
          searchParameters={searchParameters}
          updatingSearchParameters={updatingSearchParameters}
        />
      </div>
    </div>
  );
}
export default observer(Filters);
